import {
  ModalWindowDataTypes,
  ModalWindowDataType
} from './types'
import {
  ModalWindowProps,
  ModalWindowType
} from "../../hoc/ModalWindowGuard/ModalWindowGuard"

export const openModalWindow = <T extends ModalWindowType>(
  type: T,
  data?: ModalWindowProps<T>,
): ModalWindowDataType => ({
  type: ModalWindowDataTypes.OPEN_MODAL_WINDOW,
  data,
  modalType: type,
})
export const closeModalWindow = (): ModalWindowDataType => ({type: ModalWindowDataTypes.CLOSE_MODAL_WINDOW})
